import React, {useState, useEffect} from "react";
import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
    Select,
    Menu,
    FormControlLabel,
    MenuItem,
    Checkbox,
} from "@material-ui/core";

const MultiControlledIdOptionSelect = ({
                                           label,
                                           id,
                                           value,
                                           options,
                                           onChange,
                                           hasError,
                                           isRequired
                                       }) => {
    const [localValue, setLocalValue] = useState(
        Array.isArray(value) ? value : [],
    );
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        setLocalValue(value || []);
    }, [value]);

    const handleChange = (newValue) => {
        setLocalValue(newValue);
        onChange({target: {name: id, value: newValue}});
    };

    const toggleCheckbox = (option) => {
        let newValue;
        if (option._id === "ALL") {
            handleChange([]);
            return;
        }
        const isSelected = localValue.some((item) => item === option._id);
        newValue = isSelected
            ? localValue.filter((item) => item !== option._id)
            : [...localValue, option._id];

        newValue = newValue.filter(
            (item) => item._id !== "ALL",
        );

        handleChange(newValue);
    };

    const isOptionChecked = (option) => {
        if (option._id === "ALL") {
            return !localValue.length
        }
        return localValue.some((item) => item === option._id);
    };

    const renderValue = (selected) => {
        if (!Array.isArray(selected) || selected.length === 0) {
            return "All";
        }
        return selected
            .map((item) => options.find((opt) => opt._id === item)?.name)
            .join(", ");
    };

    return (
        <Box sx={{minWidth: 120}}>
            <FormControl fullWidth>
                <InputLabel>{label} <span style={{color: "red"}}>{isRequired ? "*" : ""}</span></InputLabel>
                <Select
                    name={id}
                    multiple
                    value={localValue}
                    required={isRequired}
                    label={label}
                    renderValue={renderValue}
                    onOpen={(event) => setAnchorEl(event.target)}
                    onClose={() => setAnchorEl(null)}
                    open={Boolean(anchorEl)}
                >
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        style={{marginTop: "-2px"}}
                    >
                        {options?.map((option) => {
                            return (
                                <MenuItem
                                    key={option.id}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isOptionChecked(
                                                    option,
                                                )}
                                                onChange={() =>
                                                    toggleCheckbox(option)
                                                }
                                            />
                                        }
                                        label={option.name}
                                    />
                                </MenuItem>
                            );
                        })}
                    </Menu>
                </Select>
                {hasError && (
                    <FormHelperText style={{color: "red"}}>
                        This is required!
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    );
};

export default MultiControlledIdOptionSelect;
